import { axiosInstanceWithoutLoader } from "@/use/utilities/axios/app/axios-instance-without-loader.js";

export async function show(clinicId, params) {
  const axios = axiosInstanceWithoutLoader().primoLab;
  let data = [];

  await axios
    .get(`/clinics/${clinicId}`, {
      params,
    })
    .then(async (resp) => {
      data = resp.data;
    })
    .catch(async (error) => {
      throw error.response.data.errors;
    });

  return { data };
}
